import { render, staticRenderFns } from "./DebtExL.vue?vue&type=template&id=b8ba054c"
import script from "./DebtExL.vue?vue&type=script&lang=js"
export * from "./DebtExL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports